var {AmpersandModel} = require('catalog/libs');

module.exports = AmpersandModel.extend({
	/**
     * state properties
     */
    props: {
        'name': 'string',
        'value': 'string'
    }
});
